"use client";

import { Alert, Spinner, Text } from "@softmax/design-system";
import {
  ResourceFeedback,
  type ChartRefreshState,
  type ChartState,
} from "@softmax/web-ux/resource-feedback";

export type PolicyRefreshState = ChartRefreshState;
export type PolicyResourceState<Content extends object> = ChartState<Content>;

export function PolicyStateFeedback({
  state,
  subject,
  onRetry,
}: {
  readonly state: PolicyResourceState<object>;
  readonly subject: string;
  readonly onRetry?: (() => void) | undefined;
}) {
  if (onRetry)
    return (
      <ResourceFeedback state={state} subject={subject} onRefresh={onRetry} />
    );

  if (state.status === "loading")
    return (
      <output>
        <Spinner /> <Text tone="muted">Loading {subject}…</Text>
      </output>
    );

  if (state.status === "error")
    return <Alert tone="danger">{state.message}</Alert>;

  if (state.refresh?.status === "refreshing")
    return (
      <output>
        <Spinner /> <Text tone="muted">Refreshing {subject}…</Text>
      </output>
    );

  if (state.refresh?.status === "error")
    return (
      <Alert tone="danger">
        {state.refresh.message} Showing the last successful result.
      </Alert>
    );

  return null;
}
